module.exports = __webpack_public_path__ + "static/media/playIcon.d3af35b7.svg";